/*********************** Custom JS for Boost AI Search & Discovery  ************************/

/* Starts Boost 200778 */

if (window.boostSDAppConfig) {

window.boostSDAppConfig.integration =  Object.assign({

wishlists: 'plus'

}, window.boostSDAppConfig.integration || {});

}

const customize = {
  returnWishlist: (componentRegistry) => {
    componentRegistry.useComponentPlugin("IntegrationProductWishlist", {
      name: "Place wishlist btn on the top right corner of product image",
      enabled: true,
      apply: () => ({
        props: (props) => {
          return props;
        },
        afterRender(element) {
          console.log("integration product wishlist");
          let hasUpdated = false; // Prevent rendering twice
          const wishlistElm = element.getRootElm();
          if (wishlistElm && !hasUpdated) {
            hasUpdated = true;
            const productImages = document.querySelectorAll(
              ".boost-sd__product-image"
            ); // Select boost sd image id
            productImages.forEach((image) => {
              if (image.id === wishlistElm.getAttribute("data-product")) {
                if (!image.querySelector(".boost-sd__wishlist")) {
                  image.prepend(wishlistElm);
                }
              }
            });
          }
        },
      }),
    });
  },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customize.returnWishlist,
]);

/* Ends Boost 200778 */

// Start Boost 217765
// Move collection description to below product list
const customHeader = {
    moveHeaderDescription: (componentRegistry) => {
        componentRegistry.useComponentPlugin("HeaderDescription", {
            name: "Move Collection Description Below Product List",
            apply: () => {
                let hasUpdated = false; // Prevent rendering twice
                return {
                    afterRender(element) {
                        const descriptionElement = element.getRootElm();
                        if (descriptionElement && !hasUpdated) {
                            hasUpdated = true;
                            const productListContainerElement =
                                document.querySelector(
                                    ".boost-sd-layout.boost-sd-layout--has-filter-vertical"
                                ); // Select product list
                            if (productListContainerElement) {
                                productListContainerElement.insertAdjacentElement(
                                    "afterend",
                                    descriptionElement
                                ); // Move to below product list
                            }
                        }
                    },
                };
            },
        });
    },
};

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    customHeader.moveHeaderDescription,
]);
// End Boost 217765

